import type { DataShape } from '../../services/fields';

export const PREFIX: keyof Pick<DataShape, 'proxy'> = 'proxy';
